import type { BoxProps } from '@mui/material/Box';
import MUIBox from '@mui/material/Box';

const Box = (props: BoxProps) => {
  return <MUIBox {...props} />;
};

export default Box;
